const getDefaultState = () => ({
  search: {
    loading: false,
    error: false,
    brands: {
      items: [],
    },
    giftVouchers: {
      items: [],
    },
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/gift-vouchers/defaultState.js